import script from "./grid-body.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-body.vue?vue&type=script&setup=true&lang=ts"

import "./grid-body.vue?vue&type=style&index=0&id=09f32c16&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f32c16"]])

export default __exports__